export default {"src":"/_next/static/media/pesko.a7223a5d.svg","height":71,"width":176,"blurWidth":0,"blurHeight":0};